import { ContextMenuView } from "./view/contextMenuView";
import { useEffect, useRef, useState } from "react";
import { NB_ContextMenuProps } from "./type/contextMenu.type";
import useClickOutside from "./hooks/clickOutside";

export const NbContextMenu = ({ hideList, ...rest }: NB_ContextMenuProps) => {
  const [isHidden, setIsHidden] = useState(hideList);
  const containerRef = useRef<HTMLDivElement>(null);


  useEffect(() => {
    setIsHidden(hideList);
  }, [hideList]);

  const hideListFn = () => {
    setIsHidden((prev) => !prev);
  };

  useClickOutside(containerRef, () => setIsHidden(true)); // Make sure hook accepts nullable ref

  return (
    <div ref={containerRef as React.RefObject<HTMLDivElement>}>
      <ContextMenuView
        {...rest}
        isHidden={isHidden}
        setIsHidden={setIsHidden}
        hideListFn={hideListFn}
      />
    </div>
  );
};
